import '@pc/styles/play_card_infomation.css';

import { Skeleton } from '@pc/components/ui/skeleton';

function PlayerInfomationSkeleton() {
  return (
    <div className='border-b p-[16px_20px]'>
      <div className='flex h-[85px] w-full items-start'>
        <Skeleton className='relative h-[48px] w-[48px] shrink-0 overflow-hidden rounded-full' />
        <div className='ml-[24px] flex flex-1 flex-col self-center'>
          <Skeleton className='flex items-center font-medium text-[18px]' style={{ overflowWrap: 'break-word' }}>
            <div className='block overflow-hidden text-ellipsis whitespace-nowrap' />
          </Skeleton>
          <div className='flex flex-col'>
            <Skeleton className='mb-4 h-6 w-56' />
            <Skeleton className='mb-4 h-4 w-20' />
            <Skeleton className='mb-2 h-4 w-[360px]' />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlayerInfomationSkeleton;
